import { types } from './types'

interface AuthProtocol {
  payload: any
  type: string
}
interface PopupModuleStateProps {
  formData: object
  openImages: boolean
  openStylesheets: boolean
}

const INITIAL_STATE: PopupModuleStateProps = {
  formData: {},
  openImages: false,
  openStylesheets: false,
}

export const popupReducer = (
  state = INITIAL_STATE,
  { type, payload }: AuthProtocol,
) => {
  if (type === types.UPDATE_FORMDATA) {
    return { ...state, formData: payload }
  }
  if (type === types.OPEN_IMAGES) {
    return { ...state, openImages: !state.openImages }
  }
  if (type === types.OPEN_STYLESHEET) {
    return { ...state, openStylesheets: !state.openStylesheets }
  }
  return state
}
